import React from 'react';
import { Badge } from '../ui/badge';

// Ticket status -> color mapping, per product spec:
// green=new, blue=open, yellow=waiting, orange=archived
export const STATUS_STYLES = {
  new: { label: 'New', className: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100 border-emerald-200' },
  open: { label: 'Open', className: 'bg-blue-100 text-blue-700 hover:bg-blue-100 border-blue-200' },
  waiting: { label: 'Waiting', className: 'bg-amber-100 text-amber-700 hover:bg-amber-100 border-amber-200' },
  archived: { label: 'Archived', className: 'bg-orange-100 text-orange-700 hover:bg-orange-100 border-orange-200' },
};

export const PRIORITY_STYLES = {
  low: 'bg-slate-100 text-slate-600 hover:bg-slate-100',
  medium: 'bg-blue-50 text-blue-600 hover:bg-blue-50',
  high: 'bg-red-100 text-red-700 hover:bg-red-100',
};

export function TicketStatusBadge({ status, testId }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.new;
  return (
    <Badge className={`border ${style.className}`} data-testid={testId || `ticket-status-${status}`}>
      {style.label}
    </Badge>
  );
}

export function TicketPriorityBadge({ priority, testId }) {
  return (
    <Badge className={PRIORITY_STYLES[priority] || PRIORITY_STYLES.medium} data-testid={testId || `ticket-priority-${priority}`}>
      {(priority || 'medium').charAt(0).toUpperCase() + (priority || 'medium').slice(1)}
    </Badge>
  );
}
